import type { SubtitleBlock as SubtitleBlockType } from '../types';

// ─────────────────────────────────────────────
// SubtitleBlock — 小标题 / 分节标签
// Figma: paragraph small/regular + #737373（灰色），上方留白起分隔作用
// ─────────────────────────────────────────────
export function SubtitleBlock({ block }: { block: SubtitleBlockType }) {
  if (!block.text) return null;
  return <p className="text-[14px] text-[#737373] leading-[1.5] ">{block.text}</p>;
}
